module.exports = "/static/assets/d8c268c304caec7b98b44bc3675d728a.png";